module.exports = __webpack_public_path__ + "static/media/brc2.c29288b8.png";